import ModelViewer from './ModelViewer'

const style = String.raw`
	<style>
		h1.beta {
			position: absolute;
			bottom: 0;
			left: 0;
			z-index: 1000;

			font-size: 4vmax;
			font-weight: 100;

			color:rgba(128, 128, 128, .25);
			user-select: none;
			pointer-events: none;
		}

	</style>
`

export class BetaIndicator {
	viewer: ModelViewer
	header: HTMLHeadingElement

	constructor(viewer: ModelViewer) {
		this.viewer = viewer
		this.viewer.shadowRoot.append(parseHTML(style))
		this.header = document.createElement('h1')
		this.header.classList.add('beta')
		this.header.innerText = 'Realtime Beta'
		this.viewer.shadowRoot.append(this.header)
	}
}

function parseHTML(html) {
	var t = document.createElement('template')
	t.innerHTML = html
	return t.content
}
